/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FirmwareType,
    FirmwareTypeFromJSON,
    FirmwareTypeFromJSONTyped,
    FirmwareTypeToJSON,
} from './FirmwareType';

/**
 * 
 * @export
 * @interface ReportForFirmwareGroupsEntryByStbGroupResponseCounters
 */
export interface ReportForFirmwareGroupsEntryByStbGroupResponseCounters {
    /**
     * 
     * @type {string}
     * @memberof ReportForFirmwareGroupsEntryByStbGroupResponseCounters
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForFirmwareGroupsEntryByStbGroupResponseCounters
     */
    name: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForFirmwareGroupsEntryByStbGroupResponseCounters
     */
    size: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForFirmwareGroupsEntryByStbGroupResponseCounters
     */
    loaderVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForFirmwareGroupsEntryByStbGroupResponseCounters
     */
    firmwareVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForFirmwareGroupsEntryByStbGroupResponseCounters
     */
    uiVersion: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForFirmwareGroupsEntryByStbGroupResponseCounters
     */
    nbLoaderSuccessCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForFirmwareGroupsEntryByStbGroupResponseCounters
     */
    nbFirmwareSuccessCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForFirmwareGroupsEntryByStbGroupResponseCounters
     */
    nbUiSuccessCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForFirmwareGroupsEntryByStbGroupResponseCounters
     */
    nbConnectedWithinLast24H: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForFirmwareGroupsEntryByStbGroupResponseCounters
     */
    nbConnectionFailureCountLast1M: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForFirmwareGroupsEntryByStbGroupResponseCounters
     */
    nbConnectionFailureCountLast3M: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForFirmwareGroupsEntryByStbGroupResponseCounters
     */
    nbConnectionFailureCountLast6M: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForFirmwareGroupsEntryByStbGroupResponseCounters
     */
    quota: number | null;
    /**
     * 
     * @type {FirmwareType}
     * @memberof ReportForFirmwareGroupsEntryByStbGroupResponseCounters
     */
    quotaFirmwareType: FirmwareType;
}

export function ReportForFirmwareGroupsEntryByStbGroupResponseCountersFromJSON(json: any): ReportForFirmwareGroupsEntryByStbGroupResponseCounters {
    return ReportForFirmwareGroupsEntryByStbGroupResponseCountersFromJSONTyped(json, false);
}

export function ReportForFirmwareGroupsEntryByStbGroupResponseCountersFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForFirmwareGroupsEntryByStbGroupResponseCounters {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'size': json['size'],
        'loaderVersion': json['loaderVersion'],
        'firmwareVersion': json['firmwareVersion'],
        'uiVersion': json['uiVersion'],
        'nbLoaderSuccessCount': json['nbLoaderSuccessCount'],
        'nbFirmwareSuccessCount': json['nbFirmwareSuccessCount'],
        'nbUiSuccessCount': json['nbUiSuccessCount'],
        'nbConnectedWithinLast24H': json['nbConnectedWithinLast24H'],
        'nbConnectionFailureCountLast1M': json['nbConnectionFailureCountLast1M'],
        'nbConnectionFailureCountLast3M': json['nbConnectionFailureCountLast3M'],
        'nbConnectionFailureCountLast6M': json['nbConnectionFailureCountLast6M'],
        'quota': json['quota'],
        'quotaFirmwareType': FirmwareTypeFromJSON(json['quotaFirmwareType']),
    };
}

export function ReportForFirmwareGroupsEntryByStbGroupResponseCountersToJSON(value?: ReportForFirmwareGroupsEntryByStbGroupResponseCounters | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'size': value.size,
        'loaderVersion': value.loaderVersion,
        'firmwareVersion': value.firmwareVersion,
        'uiVersion': value.uiVersion,
        'nbLoaderSuccessCount': value.nbLoaderSuccessCount,
        'nbFirmwareSuccessCount': value.nbFirmwareSuccessCount,
        'nbUiSuccessCount': value.nbUiSuccessCount,
        'nbConnectedWithinLast24H': value.nbConnectedWithinLast24H,
        'nbConnectionFailureCountLast1M': value.nbConnectionFailureCountLast1M,
        'nbConnectionFailureCountLast3M': value.nbConnectionFailureCountLast3M,
        'nbConnectionFailureCountLast6M': value.nbConnectionFailureCountLast6M,
        'quota': value.quota,
        'quotaFirmwareType': FirmwareTypeToJSON(value.quotaFirmwareType),
    };
}

